import { create } from "zustand";

export const useBottomNotificationStore = create((set) => ({
  notifications: [],

  /**
   * Show a bottom notification bar.
   * @param {string} message - The message to display
   * @param {string} type - "warning" | "error" | "info" | "success"
   * @param {number} duration - Auto-dismiss after ms (default 5000, 0 = no auto-dismiss)
   */
  showNotification: (message, type = "warning", duration = 5000) => {
    const id = Date.now() + Math.random();

    set((state) => ({
      notifications: [...state.notifications, { id, message, type }],
    }));

    if (duration > 0) {
      setTimeout(() => {
        set((state) => ({
          notifications: state.notifications.filter((n) => n.id !== id),
        }));
      }, duration);
    }

    return id;
  },

  dismissNotification: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    }));
  },

  clearAll: () => {
    set({ notifications: [] });
  },
}));
